module.exports = __webpack_public_path__ + "static/img/mypage-navigation-menu03.fda99492.svg";